import { useCallback, useState } from 'react';
import { initialUnitDrafts, useUnitDrafts } from './useUnitDrafts';

export function useUnitText(initial, kind, unitSystem) {
  const [state, setState] = useState(() => initialUnitDrafts({ value: initial }, { value: kind }, unitSystem));
  const getCanonical = useUnitDrafts(state, setState, { value: kind }, unitSystem);
  const setValue = useCallback(value => setState(current => ({ value: typeof value === 'function' ? value(current.value) : value })), []);
  const canonicalValue = useCallback(raw => getCanonical('value', raw, kind), [getCanonical, kind]);
  return [state.value, setValue, canonicalValue];
}
